module.exports = __webpack_public_path__ + "img/KurdoShaban-NadastiPekrd.68113c1e.jpg";